import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CareerCounsellingRedirect from "./product/career_counselling/CareerCounsellingRedirect";
import LoaderGif from "../../assets/gifs/LoaderGif.gif";

const Redirection = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const product = searchParams.get("product");
  const task = searchParams.get("task");

  const [isInIframeAndRedirecting, setIsInIframeAndRedirecting] = useState(window.self !== window.top);

  useEffect(() => {
    if (window.self !== window.top) {
      // Send product and task to the parent window.
      window.parent.postMessage({ type: "iframeRedirectInmobius", product: product, task: task }, "*");
    } else {
      setIsInIframeAndRedirecting(false);
    }
  }, [product, task]);

  if (isInIframeAndRedirecting) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column"
        }}
      >
        <img
          src={LoaderGif}
          alt="Loading..."
          style={{
            width: "100px",
            height: "100px"
          }}
        />
      </div>
    );
  }

  const renderRedirectComponent = () => {
    switch (product?.toLowerCase()) {
      case "career_counseling":
        return <CareerCounsellingRedirect task={task} />;
      default:
        return (
          <div className="error-container">
            <h2>Invalid Product Type</h2>
            <p>The requested product type is not supported.</p>
          </div>
        );
    }
  };

  return renderRedirectComponent();
};

export default Redirection;
